import { useCallback } from 'react'
import { useBackfillRecurringTasks } from '../services/api/recurring-tasks.hooks'
import { useFetchExternalTasks } from '../services/api/tasks.hooks'
import { useGTQueryClient } from '../services/queryUtils'

const useRefetchStaleQueries = (isEnabled = true) => {
    const queryClient = useGTQueryClient()
    const { refetch: refetchExternalTasks } = useFetchExternalTasks(isEnabled)
    const { refetch: backfillRecurringTasks } = useBackfillRecurringTasks(isEnabled)
    return useCallback(async () => {
        await Promise.all([backfillRecurringTasks(), refetchExternalTasks()])
        // Goals never go stale on their own (staleTime: Infinity), yet the server recounts this week
        // on every read, so a refresh has to ask for them by name. Only mounted lists are refetched.
        queryClient.invalidateQueries('goals')
        queryClient.refetchQueries({ stale: true })
    }, [backfillRecurringTasks, queryClient, refetchExternalTasks])
}

export default useRefetchStaleQueries
